import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function MetaPixelTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Initialize Meta Pixel if not already done
    if (!window.fbq) {
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

      window.fbq('init', '3077978955726054');
    }
  }, []);

  useEffect(() => {
    // Track page view on every route change
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [pathname]);

  return null;
}

// Main application component with routing
export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <MetaPixelTracker />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="om-os" element={<About />} />
          <Route path="ydelser" element={<Services />} />
          <Route path="ydelser/:slug" element={<ServiceDetail />} />
          <Route path="galleri" element={<Gallery />} />
          <Route path="kontakt" element={<Contact />} />
        </Route>
      </Routes>
    </HelmetProvider>
  );
}
